import { Yup } from "@pharmupp/p3-front-commons"

export const createUserModalSchema = Yup.object({
  lastName: Yup.string().required().max(50),
  firstName: Yup.string().required().max(50),
  email: Yup.string().email().required().max(75),
})
